module.exports = __webpack_public_path__ + "img/add.2fbdb7ae.svg";